export function merchantDataToPayload({ merchantGroupIds, merchantIds }) {
  return {
    merchant_group_list: String(merchantGroupIds),
    merchant_list: !!merchantIds ? merchantIds : null,
  };
}
